import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome'
import dynamic from 'next/dynamic'

const FontAwesomeIcon = dynamic(() => import('./FontAwesomeIcon'), { ssr: false })

const Icon = (props: FontAwesomeIconProps): JSX.Element => {
  return <FontAwesomeIcon {...props} />
}

export default Icon
